export const notice = [
    {noticeNum : 1, noticeTitle : 'ドクターインホームアプリ発売のご案内', noticeWriter : 'ドクターインホーム', noticeRdcnt : 0, noticeDate : '2024-04-18', noticeContent : `
                <img src="${require('@/assets/images/item-3eng.png')}" alt="DoctorInHome app image" class="centered-image">
            `},
]